import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import axios from 'axios'
import i18n from './i18n'
import money from 'v-money'
import VueTheMask from 'vue-the-mask'
import 'magnific-popup'
import 'magnific-popup/dist/magnific-popup.css'
import VuejsDialog from 'vuejs-dialog'

// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

// Tell Vue to install the plugin.
Vue.use(VuejsDialog, {
  html: true,
  loader: true,
  okText: 'OK',
  cancelText: 'Cancelar',
  animation: 'bounce'
})

// Jquery
import jQuery from 'jquery'
global.jQuery = jQuery
global.$ = jQuery

// Bootstrap e Boostrap-Vue
let Bootstrap = require('bootstrap')
import 'bootstrap/dist/css/bootstrap.css'

// Mask money
Vue.use(money)
// Vuw-the-mask
Vue.use(VueTheMask)

axios.defaults.withCredentials = true
axios.defaults.timeout = 15000

Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  i18n,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js